import React from 'react'

import './DrawerToggleButton.css'

const drawerToggleButton = props => (
  <button className="toggle-button" onClick={props.click}>
<h5 style={{fontWeight:500}} >{props.text}</h5>
  </button>
)

export default drawerToggleButton